import { useState, useEffect, useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useWorkWithUs } from 'contexts/WorkWithUs.contexts';
import { Utils } from 'utils';
import api from 'service';

function getSteps() {
    return ['Região', 'Contato', 'Informações Básicas', 'Informações Complementares', 'Cursos Profissionalizantes'];
}

const useRegister = () => {
    const [loadingPage, setLoadingPage] = useState(true);
    const [transitionIn, setTransitionIn] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [completed, setCompleted] = useState([]);
    const [loading, setLoading] = useState(false);
    const steps = getSteps();
    const history = useHistory();

    const { t: translate } = useTranslation();

    const {
        dataFields,
        statusError,
        openModal,
        openAlert,
        handleOpenAlert,
        handleCloseAlert,
        updateErrors,
        updateStatusError,
        clearDataField,
    } = useWorkWithUs();

    document.title = translate('workWithUs.head.register.title');

    const isVigilant = useMemo(() => {
        return dataFields.typeOfVacancy?.type === '1';
    }, [dataFields]);

    useEffect(() => {
        window.scrollTo(0, 0);
        setLoadingPage(false);
        setTimeout(() => {
            setTransitionIn(true);
        }, 100);
    }, []);

    const hadleGoback = () => {
        history.push(Utils.setPrefix(`/trabalhe-conosco/selecione-tipo-vaga`));
    };

    const onValidate = useCallback(
        (step) => {
            let status = statusError;

            const { contact, address, basicInformation } = dataFields;

            if (step === 1) {
                let errorContact = {
                    cpf: false,
                    name: false,
                    gender: false,
                    genderExtra: false,
                    sexualOrientation: false,
                    cellphone: false,
                    email: false,
                    origin_contact: false,
                };

                if (!contact?.cpf || !Utils.validateCPF(contact?.cpf)) {
                    errorContact.cpf = true;
                    status = true;
                }
                if (!contact?.name || contact?.name.length < 4) {
                    errorContact.name = true;
                    status = true;
                }

                if (!contact?.gender) {
                    errorContact.gender = true;
                    status = true;
                }

                if (!contact?.genderExtra) {
                    errorContact.genderExtra = true;
                    status = true;
                }

                if (!contact?.sexualOrientation) {
                    errorContact.sexualOrientation = true;
                    status = true;
                }

                if (!contact?.origin_contact) {
                    errorContact.origin_contact = true;
                    status = true;
                }

                if (
                    !contact?.cellphone ||
                    !Utils.validateCellPhone(contact?.cellphone) ||
                    Utils.clearMask(contact.cellphone) !== Utils.clearMask(contact.cellphone2)
                ) {
                    errorContact.cellphone = true;
                    status = true;
                }
                if (!contact?.email || !Utils.validateEmail(contact?.email)) {
                    errorContact.email = true;
                    status = true;
                }

                updateErrors('contact', errorContact);
            }

            if (step === 2) {
                let errorBasicInformation = {
                    birthDate: false,
                    maritalStatus: false,
                    educationalInstitution: false,
                    weight: false,
                    height: false,
                    reservist: false,
                    pcdCid: false,
                    bloodType: false,
                    educationLevel: false,
                    vvdmp: false,
                };

                if (basicInformation?.isPcd && !basicInformation?.pcdCid) {
                    errorBasicInformation.pcdCid = true;
                    status = true;
                }

                if (!basicInformation?.vvdmp) {
                    errorBasicInformation.vvdmp = true;
                    status = true;
                }

                if (!basicInformation?.educationLevel) {
                    errorBasicInformation.educationLevel = true;
                    status = true;
                }

                // if (!basicInformation?.rg || Utils.clearMask(basicInformation?.rg).length < 5) {
                //     errorBasicInformation.rg = true;
                //     status = true;
                // }

                if (isVigilant && !dataFields.basicInformation?.bloodType) {
                    errorBasicInformation.bloodType = true;
                    status = true;
                }

                // if (!basicInformation?.rgIssuingAgency) {
                //     errorBasicInformation.rgIssuingAgency = true;
                //     status = true;
                // }

                // if (!basicInformation?.naturalness) {
                //     errorBasicInformation.naturalness = true;
                //     status = true;
                // }

                // if (!basicInformation?.rgIssuingState) {
                //     errorBasicInformation.rgIssuingState = true;
                //     status = true;
                // }

                // if (!basicInformation?.rgIssuingCity) {
                //     errorBasicInformation.rgIssuingCity = true;
                //     status = true;
                // }

                //basicInformation.rgIssuingCity
                // if (!basicInformation?.naturalnessState) {
                //     errorBasicInformation.naturalnessState = true;
                //     status = true;
                // }

                // if (!basicInformation?.nationality) {
                //     errorBasicInformation.nationality = true;
                //     status = true;
                // }

                if (!basicInformation?.birthDate) {
                    errorBasicInformation.birthDate = true;
                    status = true;
                }
                if (!basicInformation?.maritalStatus) {
                    errorBasicInformation.maritalStatus = true;
                    status = true;
                }

                /*
                if (isVigilant && !basicInformation?.reservist) {
                  errorBasicInformation.reservist = true;
                  status = true;
                }
                */

                if (!basicInformation?.colorRace) {
                    errorBasicInformation.colorRace = true;
                    status = true;
                }

                // if (!basicInformation?.motherName) {
                //     errorBasicInformation.motherName = true;
                //     status = true;
                // }

                if (!basicInformation?.hasCnh) {
                    errorBasicInformation.hasCnh = true;
                    status = true;
                }
                if (basicInformation?.hasCnh === 'SIM') {
                    if (!basicInformation?.driverLicenceCategory) {
                        errorBasicInformation.driverLicenceCategory = true;
                        status = true;
                    }
                    if (!basicInformation?.driverExpirationDate) {
                        errorBasicInformation.driverExpirationDate = true;
                        status = true;
                    }
                }

                if (basicInformation?.typePixKey === 'email') {
                    if (!Utils.validateEmail(basicInformation?.pixKey)) {
                        errorBasicInformation.pixKey = true;
                        errorBasicInformation.typePixKey = true;
                        status = true;
                    }
                }

                updateErrors('basicInformation', errorBasicInformation);
            }

            if (step === 3) {
                let errorAddress = {
                    cep: false,
                    street: false,
                    number: false,
                    neighborhood: false,
                    city: false,
                    state: false,
                    publicPlace: false,
                    region: false,
                };
                if (!address?.cep || Utils.clearMask(address?.cep).length < 8) {
                    errorAddress.cep = true;
                    status = true;
                }
                if (!address?.street) {
                    errorAddress.street = true;
                    status = true;
                }
                if (!address?.publicPlace) {
                    errorAddress.publicPlace = true;
                    status = true;
                }
                if (!address?.number) {
                    errorAddress.number = true;
                    status = true;
                }
                if (!address?.neighborhood) {
                    errorAddress.neighborhood = true;
                    status = true;
                }
                if (!address?.city) {
                    errorAddress.city = true;
                    status = true;
                }
                if (!address?.state || Utils.clearMask(address?.state).length < 2) {
                    errorAddress.state = true;
                    status = true;
                }

                if (!address?.region) {
                    errorAddress.region = true;
                    status = true;
                }

                updateErrors('address', errorAddress);
            }

            // if (step === 4) {
            //     let errorBasicInformation = {
            //         bloodType: false,
            //     };

            //     if (isVigilant && !dataFields.basicInformation?.bloodType) {
            //         errorBasicInformation.bloodType = true;
            //         status = true;
            //     }

            //     updateErrors('basicInformation', errorBasicInformation);
            // }

            updateStatusError(status);
            return status;
        },
        [dataFields, isVigilant, statusError, updateErrors, updateStatusError],
    );

    const onValidateFinish = useCallback(
        (step) => {
            let status = false;
            const { specializations, cnv_anexo, firstJob, experience, curriculum } = dataFields;

            if (step === 4) {
                let errorSpecializations = {
                    cnv: false,
                    validate_cnv: false,
                    cnv_anexo: false,
                    experience: false,
                    date_lastRecycle: false
                };
                if (isVigilant && !specializations?.first_copy_cnv && !specializations?.validate_cnv) {
                    status = true;
                    errorSpecializations.validate_cnv = true;
                }
                if (isVigilant && !specializations?.first_copy_cnv && !specializations?.cnv) {
                    errorSpecializations.cnv = true;
                    status = true;
                }
                if (isVigilant && !specializations?.first_copy_cnv && !specializations?.cnv) {
                    errorSpecializations.cnv = true;
                    status = true;
                }
                if (isVigilant && !specializations?.date_lastRecycle) {
                    errorSpecializations.date_lastRecycle = true;
                    status = true;
                }
                if (isVigilant && !specializations?.first_copy_cnv && !cnv_anexo?.name) {
                    status = true;
                    errorSpecializations.cnv_anexo = true;
                }
                //console.log('validate...', { firstJob, experience });
                if (firstJob === undefined || firstJob === false) {
                    if (
                        (experience === undefined || experience.length === 0) &&
                        (curriculum === undefined || Object.keys(curriculum).length === 0)
                    ) {
                        status = true;
                        errorSpecializations.experience = true;
                    }
                }

                updateErrors('specializations', errorSpecializations);
            }

            updateStatusError(status);
            return status;
        },
        [dataFields, isVigilant, updateErrors, updateStatusError],
    );

    const totalSteps = useCallback(() => {
        return getSteps().length;
    }, []);

    const isLastStep = useCallback(() => {
        return activeStep === totalSteps() - 1;
    }, [activeStep, totalSteps]);

    const onCompleted = useCallback(
        (step) => {
            if (activeStep === step - 1) {
                setCompleted([...completed, step]);
            }
        },
        [activeStep, completed],
    );

    const handleNext = useCallback(() => {
        const newActiveStep = isLastStep()
            ? steps.findIndex((step, i) => !completed.find((item) => item === i))
            : activeStep + 1;

        if (onValidate(newActiveStep)) {
            handleOpenAlert(translate('workWithUs.form.validated.fillInTheInformation'));
            return;
        }

        setActiveStep(newActiveStep);
        onCompleted(newActiveStep);
    }, [isLastStep, steps, activeStep, onValidate, onCompleted, completed, handleOpenAlert, translate]);

    const handleBack = useCallback(() => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        updateStatusError(false);
    }, [updateStatusError]);

    const handleOnRegister = useCallback(async () => {
        console.log('firstJob', dataFields?.firstJob);
        console.log('experience', dataFields?.experience);
        console.log('curriculum', dataFields?.curriculum?.file);

        if (onValidateFinish(activeStep)) {
            handleOpenAlert(translate('workWithUs.form.validated.fillInTheInformation'));
            return;
        }

        //console.log('dataFields', dataFields);

        const {
            typeOfVacancy,
            //typeOfContract,
            regions,
            vtBusLines,
            contact,
            address,
            basicInformation,
            guardTrainingCourse,
            lastRecycle,
            extensionCourse,
            experience,
            curriculum,
            cnv_anexo,
            lastRecycle_anexo,
            specializations
        } = dataFields;

        const newBirthDate = basicInformation?.birthDate ? new Date(basicInformation.birthDate) : null;
        const newTimeCourse = basicInformation.timeCourse ? new Date(basicInformation.timeCourse) : null;
        // const newDispatchDate = basicInformation.rgDispatchDate ? new Date(basicInformation.rgDispatchDate) : null;
        const newDriverExpirationDate = basicInformation.driverExpirationDate
            ? new Date(basicInformation.driverExpirationDate)
            : null;

        const newCnhPrimeiraHabilitacao = basicInformation.driverFirstLicenceDate
            ? new Date(basicInformation.driverFirstLicenceDate)
            : null;

        const newCtpsEmissaoDate = basicInformation.ctpsDispatchDate
            ? new Date(basicInformation.ctpsDispatchDate)
            : null;
        const data_nascimento = newBirthDate
            ? `${newBirthDate.getDate().toString().padStart(2, '0')}/${(newBirthDate.getMonth() + 1)
                  .toString()
                  .padStart(2, '0')}/${newBirthDate.getFullYear()}`
            : '';

        /*
    const rg_data_expedicao = (newDispatchDate) ? `${newDispatchDate
      .getDate()
      .toString()
      .padStart(2, "0")}/${(newDispatchDate.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${newDispatchDate.getFullYear()}` : '';
    */
        const cnh_validade = newDriverExpirationDate
            ? `${newDriverExpirationDate.getDate().toString().padStart(2, '0')}/${(
                  newDriverExpirationDate.getMonth() + 1
              )
                  .toString()
                  .padStart(2, '0')}/${newDriverExpirationDate.getFullYear()}`
            : '';

        const cnh_primeira_habilitacao = newCnhPrimeiraHabilitacao
            ? `${newCnhPrimeiraHabilitacao.getDate().toString().padStart(2, '0')}/${(
                  newCnhPrimeiraHabilitacao.getMonth() + 1
              )
                  .toString()
                  .padStart(2, '0')}/${newCnhPrimeiraHabilitacao.getFullYear()}`
            : '';

        const ctps_emissao = newCtpsEmissaoDate
            ? `${newCtpsEmissaoDate.getDate().toString().padStart(2, '0')}/${(newCtpsEmissaoDate.getMonth() + 1)
                  .toString()
                  .padStart(2, '0')}/${newCtpsEmissaoDate.getFullYear()}`
            : '';

        const periodo = newTimeCourse
            ? `${newTimeCourse.getDate().toString().padStart(2, '0')}/${(newTimeCourse.getMonth() + 1)
                  .toString()
                  .padStart(2, '0')}/${newTimeCourse.getFullYear()}`
            : '';

        const dateValidateCnv = specializations?.validate_cnv
            ? `${new Date(specializations.validate_cnv).getDate().toString().padStart(2, '0')}/${(new Date(specializations.validate_cnv).getMonth() + 1).toString().padStart(2, '0')}/${new Date(specializations.validate_cnv).getFullYear()}`
            : '';

        const dateLastRecycle = !!specializations?.date_lastRecycle
        ? `${new Date(specializations.date_lastRecycle).getDate().toString().padStart(2, '0')}/${(new Date(specializations?.date_lastRecycle).getMonth() + 1)
                  .toString()
                  .padStart(2, '0')}/${new Date(specializations?.date_lastRecycle).getFullYear()}` : '';

        const info_basica = {
            cpf: Utils.clearMask(contact.cpf),
            data_nascimento,
            estado_civil: basicInformation.maritalStatus,
            sexo: basicInformation.gender,
            orientacaoSexual: basicInformation.sexualOrientation,
            genero: basicInformation.genderExtra,
            tipo_sanguineo: basicInformation.bloodType,
            grau_instrucao: basicInformation.educationLevel,
            instituicao_ensino: basicInformation.educationalInstitution,
            curso: basicInformation.course,
            periodo,
            covid_declaration: '',
            first_copy_cnv: basicInformation.first_copy_cnv,
            voter_registration: basicInformation.voter_registration,
            voter_registration_zone: basicInformation.voter_registration_zone,
            voter_registration_section: basicInformation.voter_registration_section,
            pis: '',
            ctps_numero: basicInformation.ctpsNumber,
            ctps_serie: basicInformation.ctpsSerie,
            ctps_uf: basicInformation.ctpsUf,
            ctps_data_expedicao: ctps_emissao,
            cnh_numero: basicInformation.driverLicenceNumber,
            cnh_categoria: basicInformation.driverLicenceCategory,
            cnh_orgao_emissor: basicInformation.driverLicenceIssuingAgency,
            cnh_validade,
            cnh_primeira_habilitacao,
            cnh_uf_emissor: basicInformation.driverLicenceUfIssuing,
            peso: basicInformation.weight,
            altura: basicInformation.height,
            tamanho_calca: basicInformation.sizePant,
            tamanho_camisa: basicInformation.sizeShirt,
            tamanho_camisete: basicInformation.sizeTshirt,
            tamanho_jaqueta: basicInformation.sizeJacket,
            tamanho_calcado: basicInformation.sizeShoe,
            disponibilidade_turno: basicInformation.availabilityPeriod,
            disponibilidade_escala: basicInformation.availabilityTimetable,
            reservista: basicInformation.reservist,
            primeiro_emprego: '',
            ctps_digital: basicInformation.ctpsDigital ? 'S' : 'N',
            candidato_pcd: basicInformation.isPcd ? 1 : 0,
            candidato_vitima_violencia_medida_protetiva: basicInformation.vvdmp.value === 'SIM' ? 1 : 0,
            cor_raca: basicInformation.colorRace,
            pcd_cid: (basicInformation.isPcd && basicInformation.pcdCid) || '',
            cnv: specializations?.cnv ?? '',
            validate_cnv: dateValidateCnv,
            date_lastRecycle: dateLastRecycle,
        };

        const formData = new FormData();
        formData.append('is_web_encoded', true);
        formData.append('tipo_trabalho', typeOfVacancy.type);
        //formData.append('tipo_vaga', typeOfContract);
        formData.append('demais_vagas', JSON.stringify(typeOfVacancy.options));
        formData.append('nome', contact.name);
        formData.append('nome_social', contact.social_name);
        formData.append('origem_contato', contact.origin_contact);
        formData.append('cpf', Utils.clearMask(contact.cpf));
        formData.append('sexo', contact.gender);
        formData.append('orientacaoSexual', contact.sexualOrientation);
        formData.append('genero', contact.genderExtra);
        formData.append('celular', Utils.clearMask(contact.cellphone));
        formData.append('email', contact.email);
        formData.append('cep', Utils.clearMask(address.cep));
        formData.append('endereco', address.street);
        formData.append('logradouro', address.publicPlace);
        formData.append('cidade', address.city);
        formData.append('uf', address.state);
        formData.append('numero', address.number);
        formData.append('bairro', address.neighborhood);
        formData.append('complemento', address.complement ?? '');
        formData.append('regiao', address.region ?? '');
        formData.append('info_basica', JSON.stringify(info_basica));
        if (curriculum) formData.append('curriculo', curriculum.file);
        if (cnv_anexo) formData.append('cnv_anexo', cnv_anexo.file);
        if (lastRecycle_anexo) formData.append('lastRecycle_anexo', lastRecycle_anexo.file);
        // if(!!specializations?.cnv) formData.append('cnv', specializations.cnv);
        // if(!!specializations?.validate_cnv) formData.append('validate_cnv', specializations.validate_cnv);

        const course1 =
            guardTrainingCourse?.map((item) => {
                const newDateOfTheConclusion = new Date(item.dateOfTheConclusion);

                const data_conclusao = `${newDateOfTheConclusion.getDate().toString().padStart(2, '0')}/${(
                    newDateOfTheConclusion.getMonth() + 1
                )
                    .toString()
                    .padStart(2, '0')}/${newDateOfTheConclusion.getFullYear()}`;

                // if (item.file && item.file.name)
                //     formData.append(`course_files[${item.name}-${item.academy}]`, item.file);
                return {
                    // curso: item.name,
                    // academia: item.academy,
                    data_conclusao,
                    tipo: 'formacao',
                };
            }) || [];

        const course2 =
            lastRecycle?.map((item) => {
                const newDateOfTheConclusion = new Date(item.dateOfTheConclusion);
                const data_conclusao = `${newDateOfTheConclusion.getDate().toString().padStart(2, '0')}/${(
                    newDateOfTheConclusion.getMonth() + 1
                )
                    .toString()
                    .padStart(2, '0')}/${newDateOfTheConclusion.getFullYear()}`;
                if (item.file && item.file.name)
                    formData.append(`course_files[${item.name}-${item.academy}]`, item.file);
                return {
                    curso: item.name,
                    academia: item.academy,
                    data_conclusao,
                    tipo: 'reciclagem',
                };
            }) || [];

        const course3 =
            extensionCourse?.map((item) => {
                const newDateOfTheConclusion = new Date(item.dateOfTheConclusion);
                const data_conclusao = `${newDateOfTheConclusion.getDate().toString().padStart(2, '0')}/${(
                    newDateOfTheConclusion.getMonth() + 1
                )
                    .toString()
                    .padStart(2, '0')}/${newDateOfTheConclusion.getFullYear()}`;
                if (item.file && item.file.name)
                    formData.append(`course_files[${item.name}-${item.academy}]`, item.file);
                return {
                    curso: item.name,
                    academia: item.academy,
                    data_conclusao,
                    tipo: 'extensao',
                };
            }) || [];
        formData.append('formacao', JSON.stringify([...course1, ...course2, ...course3]));

        const experiencia =
            experience?.map((item) => ({
                empresa: item.company,
                cargo: item.office,
                data_inicio: item.startDate,
                data_termino: item.endDate !== 'Atualmente' ? item.endDate : '',
                emprego_atual: item.endDate !== 'Atualmente' ? 'N' : 'S',
            })) || [];

        formData.append('experiencia', JSON.stringify(experiencia));

        onCompleted(5);

        setLoading(true);

        const regioes =
            regions && regions.options && regions.options.length ? regions.options.map((region) => region.label) : [];

        const vt_bus_lines =
            vtBusLines && vtBusLines.options && vtBusLines.options.length
                ? vtBusLines.options.map((bus_line) => bus_line.label)
                : [];

        formData.append('regioes', JSON.stringify(regioes));
        formData.append('vt_bus_lines', JSON.stringify(vt_bus_lines));

        console.log('enviando...', formData);

        try {
            await api.post('/trabalhe-conosco/registrar', formData).then((data) => {
                const response = JSON.parse(data.request.response);
                if (response.status === false) {
                    setLoading(false);
                    handleOpenAlert(response.message);
                    return;
                }
                setLoading(false);
                clearDataField();
                history.push(Utils.setPrefix('/trabalhe-conosco/cadastro/finalizado'));
            });
        } catch (error) {
            error.response.data.map((item) => handleOpenAlert(item));
            setLoading(false);
        }
    }, [activeStep, dataFields, history, translate, onValidateFinish, handleOpenAlert, clearDataField, onCompleted]);

    return {
        translate,
        transitionIn,
        loadingPage,
        steps,
        activeStep,
        completed,
        openModal,
        openAlert,
        loading,
        handleCloseAlert,
        hadleGoback,
        handleNext,
        handleBack,
        handleOnRegister,
    };
};

export default useRegister;
